<script setup lang="ts">
import type { Ref } from 'vue'

const variant = inject('variant') as Ref<string | undefined>

const maxOtc = computed(() => {
  return states.find((state) => state.code === ip.lookup?.stateCode)?.maxOtc
})
</script>

<template>
  <template v-if="brand.id === 'med10' && query.typ === 'clicks'">
    <div class="text-3xl sm:text-4xl text-center">
      See if you can get additional benefits with a Medicare Advantage Plan!
    </div>

    <MediaAlphaAds :user="{}" />
  </template>

  <template v-else-if="variant === 'default'">
    <div class="text-3xl sm:text-4xl text-center">
      See if you can get additional benefits with a Medicare Advantage Plan!
    </div>

    <div class="flex items-center justify-center space-x-3">
      <div class="relative flex w-2 h-2">
        <div
          class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"
        >
        </div>
        <div class="relative inline-flex rounded-full h-2 w-2 bg-green-500">
        </div>
      </div>
      <div class="sm:text-lg font-medium">
        LICENSED INSURANCE AGENTS AVAILABLE
      </div>
    </div>

    <ClickToCall variant="red">
      <template #text>
        <span class="text-2xl sm:text-4xl"> {{ phone.formatted }} </span>
        <br />
        <span class="text-lg sm:text-3xl font-normal">
          CLICK TO CALL (FREE)
        </span>
      </template>
    </ClickToCall>

    <div
      class="text-2xl sm:text-4xl leading-7 font-bold uppercase tracking-wider text-center text-gray-500"
    >
      Open 24/7, TTY USERS 711
    </div>
  </template>

  <template v-else-if="variant === 'groceryAllowance900'">
    <div class="text-3xl sm:text-4xl text-center">
      Do you want {{ maxOtc ? `up to $${maxOtc}` : 'an allowance' }} to use
      towards common over-the-counter items or groceries?
    </div>

    <div class="flex items-center justify-center space-x-3">
      <div class="relative flex w-2 h-2">
        <div
          class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"
        >
        </div>
        <div class="relative inline-flex rounded-full h-2 w-2 bg-green-500">
        </div>
      </div>
      <div class="sm:text-lg font-medium">
        LICENSED INSURANCE AGENTS AVAILABLE
      </div>
    </div>

    <ClickToCall variant="red">
      <template #text>
        <span class="text-2xl sm:text-4xl"> {{ phone.formatted }} </span>
        <br />
        <span class="text-lg sm:text-3xl font-normal">
          CLICK TO CALL (FREE)
        </span>
      </template>
    </ClickToCall>

    <div
      class="text-2xl sm:text-4xl leading-7 font-bold uppercase tracking-wider text-center text-gray-500"
    >
      Open 24/7, TTY USERS 711
    </div>
  </template>

  <template v-else-if="variant === 'spendingAllowances3300'">
    <div class="text-3xl sm:text-4xl text-center">
      See if you qualify for a Medicare Advantage plan with up to $3,300 in
      spending allowances!
    </div>

    <div class="flex items-center justify-center space-x-3">
      <div class="relative flex w-2 h-2">
        <div
          class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"
        >
        </div>
        <div class="relative inline-flex rounded-full h-2 w-2 bg-green-500">
        </div>
      </div>
      <div class="sm:text-lg font-medium">
        LICENSED INSURANCE AGENTS AVAILABLE
      </div>
    </div>

    <ClickToCall variant="red">
      <template #text>
        <span class="text-2xl sm:text-4xl"> {{ phone.formatted }} </span>
        <br />
        <span class="text-lg sm:text-3xl font-normal">
          CLICK TO CALL (FREE)
        </span>
      </template>
    </ClickToCall>

    <div
      class="text-2xl sm:text-4xl leading-7 font-bold uppercase tracking-wider text-center text-gray-500"
    >
      Open 24/7, TTY USERS 711
    </div>
  </template>
</template>
